// Performance Cache Management
// Simple cache cleanup and performance monitoring

window.addEventListener('load', function() {
  // Clean up old caches if Cache API is available
  if ('caches' in window) {
    caches.keys().then(function(cacheNames) {
      const oldCaches = cacheNames.filter(name => 
        name.startsWith('beatriz-furest-') && 
        name !== 'beatriz-furest-v1'
      );
      
      if (oldCaches.length > 0) {
        console.log('Performance: Cleaning up old caches');
        return Promise.all(
          oldCaches.map(cacheName => caches.delete(cacheName))
        );
      }
    }).catch(function(err) {
      console.log('Cache cleanup failed:', err);
    });
  }
  
  // Simple performance monitoring
  if ('performance' in window && 'getEntriesByType' in performance) {
    setTimeout(function() {
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation) {
        console.log('Performance: Page load time:', Math.round(navigation.loadEventEnd - navigation.fetchStart) + 'ms');
      }
    }, 1000);
  }
});